module.exports = __webpack_public_path__ + "static/media/img1.84fedd49.jpg";